// Runs at most `max` tasks at once, newest first: whatever queued earliest is
// usually the least wanted by the time a slot frees up.
const createLimiter = (max) => {
  let running = 0;
  const waiting = [];

  return async (task) => {
    if (running >= max) await new Promise((resolve) => waiting.push(resolve));
    else running += 1;
    try {
      await task();
    } finally {
      // Handed straight over, so no gap lets an extra task in.
      const resume = waiting.pop();
      if (resume) resume();
      else running -= 1;
    }
  };
};

export default createLimiter;
